import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ArchidriveRenameComponent } from './archidrive-rename';

export const ArchidriveRenameModule: string = ng
    .module('archidrive-rename', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('archidriveRenameComponent', ArchidriveRenameComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive-rename/archidrive-rename.module.ts